// extracted by mini-css-extract-plugin
export default {"tagsFilter":"TagsFilter_tagsFilter__KQTBZ","label":"TagsFilter_label__blMln","select":"TagsFilter_select__Udm0s"};